import { useContext } from 'react';
import { SpaceContext } from '@/contexts/spaceContext'

const useSpace = () => {
    const context = useContext(SpaceContext)

    if (!context) {
        throw new Error('useSpace must be used within a SpaceProvider');
    }

    return context;
};

export { useSpace }
